export const genderEnum = [
    {
        stateId: "MAN",
        stateName: "男"
    },
    {
        stateId: "WOMAN",
        stateName: "女"
    }
]